// extracted by mini-css-extract-plugin
export default {"checkboxes":"ResourceCheckboxes_checkboxes__0qs7I","checkbox":"ResourceCheckboxes_checkbox__T92mT"};